import { Component } from '@angular/core';

@Component({
    selector: 'app-tools',
    standalone: true,
    imports: [],
    template: `
        <div class="page-content">
            <h1>Tools</h1>
            <p class="lead">Manage project tools and integrations.</p>
            <div class="notice" role="status">
                <strong>Not yet available.</strong>
                <p>
                    Tool management is coming soon. There is no verified agent-facing toolbox
                    backend yet.
                </p>
            </div>
        </div>
    `,
    styles: [
        `
            .page-content {
                padding: 2rem;
            }
            h1 {
                font-size: 1.75rem;
                font-weight: 600;
                margin-bottom: 0.5rem;
                color: #1a1a1a;
            }
            .lead {
                color: #666;
                margin-bottom: 1.5rem;
            }
            .notice {
                padding: 1.5rem;
                background: white;
                border: 1px solid #e0e0e0;
                border-radius: 8px;
                color: #666;
            }
            .notice strong {
                color: #1a1a1a;
            }
            .notice p {
                margin: 0.5rem 0 0;
            }
        `,
    ],
})
export class Tools {}
